/**
 * Schema of TipoOcorrencia
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import TipoOcorrenciaSucesso from '@/model/resource/TipoOcorrenciaSucesso'

export default (model: TipoOcorrenciaSucesso): Schema => ({
    idTipoOcorrenciaSucessoPk: {
        content: model.idTipoOcorrenciaSucessoPk,
        editable: false,
    },

    idOcorrenciaExterna: {
        content: model.idOcorrenciaExterna,
    },

    idOcorrenciaExternaAlt: {
        model: 'idOcorrenciaExterna',
        content: model.idOcorrenciaExterna,
        textContent: null,
        input: InputType.MASK,
        meta: {
            required: true,
            mask: '######',
            selectall: true,
            maxlength: '999999',
        },
    },

    nome: {
        content: model.nome,
    },

    nomeAlt: {
        model: 'nome',
        content: model.nome,
        textContent: null,
        input: InputType.TEXT,
        meta: {
            required: true,
            maxlength: '63',
        },
    },

    ativo: {
        content: bool(model.ativo),
        input: InputType.CHECKBOX,
    },
})
